import Panel from './Panel';
export * from './Panel';
export * from './components/PanelContent';
export * from './components/PanelFooter';
export * from './components/PanelHeader';
export * from './components/PanelMedia';
export * from './styles';
export * from './types';
export * from './deprecated-variants';
export * from './variants';
export default Panel;
//# sourceMappingURL=index.js.map